export default __webpack_public_path__ + "static/media/LogoMayoristas.840f1b2d.svg";